<template>
  <SAIPageWrapper>
    <div class="row items-center justify-center q-mt-xl">
      <h4 class="text-grey-8">Quote Not Found</h4>
    </div>
  </SAIPageWrapper>
</template>

<script>
import { SAIPageWrapper } from 'ecx.saigon.ui.common';

export default {
  name: 'QuoteNotFound',
  components: {
    SAIPageWrapper
  }
};
</script>
